'use client'
import { defineStyleConfig, Tooltip as ChakraTooltip } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { TooltipProps } from './Tooltip.types'

const baseStyle = {
  padding: '1rem',
  borderRadius: '0.25rem',
  backgroundColor: 'gray.700',
  color: 'white',
}

export const TooltipStyle = defineStyleConfig({ baseStyle })

export default forwardRef(function Tooltip(
  props: TooltipProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraTooltip {...props} ref={ref} translate="no" />
})
